import { PusherConnectionState } from '../../pusher/pusher-constants';

type ChatConnectionState = { chatConnection: { connectionState: PusherConnectionState } };

export const getChatConnectionState = (state: ChatConnectionState) => state.chatConnection.connectionState;

export const getIsChatConnected = (state: ChatConnectionState) =>
  state.chatConnection.connectionState === PusherConnectionState.Connected;
